"use client";

import * as Sentry from "@sentry/nextjs";
import {
  Button,
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateHeader,
  EmptyStateTitle,
} from "@teral/ui";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  useEffect(() => {
    // Report the error that triggered this boundary. global-error.tsx only
    // catches failures in the root layout, so this is where most route-level
    // render/data errors are captured.
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex items-center justify-center w-full min-h-[60vh] px-4">
      <EmptyState>
        <EmptyStateHeader>
          <EmptyStateTitle>Something went wrong</EmptyStateTitle>
          <EmptyStateDescription>
            An unexpected error occurred while loading this page. Our team has been notified. Try
            again, and if the problem persists, contact support
            {error.digest ? (
              <>
                {" "}
                with reference <span className="font-mono text-gray-12">{error.digest}</span>
              </>
            ) : null}
            .
          </EmptyStateDescription>
        </EmptyStateHeader>
        <EmptyStateActions>
          <Button variant="primary" onClick={() => reset()}>
            Try again
          </Button>
          <Button variant="outline" onClick={() => router.push("/")}>
            Go to dashboard
          </Button>
        </EmptyStateActions>
      </EmptyState>
    </div>
  );
}
